module.exports = __webpack_public_path__ + "img/payment_machine.3f590866.png";